

























import Vue from 'vue';
import NOC from '@/class/common/const';
import * as models from '@/class/models/views/app';
import VariableInput, * as vi from '@/components/util/VariableInput.vue';

export default Vue.extend({
  name: 'Invitation',
  components: { VariableInput },
  props: {
    error : Object,
  },
  data() {
    return {
      accountData: new models.CAuth(),
      items: [
        {key: 'password', name: 'パスワード', type: vi.INPUT_TYPE.PASSWORD, placeholder: 'パスワード', required: true, checks: [vi.CHECK_TYPE.PASSWORD], error: '', max: 40 },
        // {key: 'passwordConfirm', name: 'パスワード確認用', type: vi.INPUT_TYPE.PASSWORD, placeholder: 'パスワード確認用', required: true, checks: [vi.CHECK_TYPE.PASSWORD], error: '', max: 40 },
      ] as vi.IVariableInput[],
      dispToggleInputs: [
        'password',
        // 'passwordConfirm',
      ],
      dispToggles: {
        password: 'password',
        // passwordConfirm: 'password',
      },
    };
  },
  computed: {
    APP_MODE() { return NOC.APP.MODE; },
  },
  watch: {
    error: {
      deep: true,
      handler(newValue: any) {
        const target = this.items.filter((v) => (v.key === newValue.key));
        target[0].error = newValue.error;
      },
    },
  },
  methods: {
    onClickInvitation() {
      // vallidation check
      if (vi.checkValues(this.accountData, this.items) > 0) {
        return;
      }
      // パスワードが確認と一致しない場合
      // if (this.accountData.password !== this.accountData.passwordConfirm) {
      //   // todo:直刺しやめたい
      //   this.items[1].error = 'パスワードが一致しません';
      //   return;
      // }
      this.$emit('invitation', this.accountData);
    },
    dispToggle(input: string) {
      const el = this.items.find((item) => item.key === input);

      if  (el) {
        if (el.type === 'text') {
          el.type = 'password';
        } else {
          el.type = 'text';
        }
      }
    },
  },
});
